import { Flex, Modal, Typography } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { surveyType } from '../../types';

const { Text } = Typography;

const DetailItemTitle = styled(Text)`
  font-size: 16px;
`;

function SurveyDetailsModal({ survey = null, closeModal }) {
  return (
    <Modal title="Details" open={!!survey} footer={null} onCancel={closeModal}>
      <Flex vertical gap={20}>
        <Flex vertical>
          <DetailItemTitle>Project name</DetailItemTitle>
          <Text type="secondary">{survey?.name}</Text>
        </Flex>
        <Flex vertical>
          <DetailItemTitle>Coding guidance</DetailItemTitle>
          <Text type="secondary">{survey?.survey_goals}</Text>
        </Flex>
      </Flex>
    </Modal>
  );
}

SurveyDetailsModal.propTypes = {
  survey: surveyType,
  closeModal: PropTypes.func.isRequired,
};

export default SurveyDetailsModal;
